import pino from 'pino'

export const loggerOptions: pino.LoggerOptions = {
  level: process.env.LOG_LEVEL || 'info',
  formatters: {
    level(label) {
      return { status: label }
    },
    // 메타의 status 가 위 level 의 status 를 덮어써 Datadog 이 레벨을 info 로 읽었다.
    log(obj) {
      if (!('status' in obj)) return obj
      const { status, ...rest } = obj
      return { ...rest, httpStatus: status }
    },
  },
  timestamp: pino.stdTimeFunctions.isoTime,
}

const logger = pino(loggerOptions)

export default logger
